import ApiGet from "../../../../api-module/api-configuration/get-api/getApi";
import ApiPost from "../../../../api-module/api-configuration/post-api/postApi";
import { CountryOption } from "../../../../component-module/component-services/input/phone-number";
import { API_ENDPOINTS } from "../../../../context-module/context-configuration/auth-provider/apiGroup/apiProvider";

export type ApiDetailResponse<T> = {
  success: boolean;
  requestId: string;
  data: T;
};

export type JobDetailDto = {
  jobId: string;
  jobCode: string;
  jobTitle: string;
  slug: string;
  description: string;

  responsibilities: string; 
  requirements: string;    
  qualification: string;  
  offer: string;         

  departmentName: string;
  jobLevelName: string;
  jobType: string;
  location: string;

  expiryAt: string | null;
  status: string;
  publishedAt: string | null;
  closedAt: string | null;
  createdAt: string;
};

export const safeJsonParse = <T,>(value: string, fallback: T): T => {
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
};

export const getJobDetailApi = (jobUuid: string) => {
  return ApiGet<ApiDetailResponse<JobDetailDto>>(
    `${API_ENDPOINTS.GET_JOB_DETAIL}?jobUuid=${jobUuid}`
  );
};

export type ApplyJobPayload = {
  fullName: string;
  email: string;
  country: string;
  phone: string;
  telephoneCode: string;
  position: string;
  message?: string;
  consent: boolean;
  file: File;
};

export const applyJobApi = (jobUuid: string, payload: ApplyJobPayload) => {
  const fd = new FormData();
  fd.append("fullName", payload.fullName);
  fd.append("email", payload.email);
  fd.append("country", payload.country);
  fd.append("phone", payload.phone);
  fd.append("position", payload.position);
  fd.append("telephoneCode", payload.telephoneCode);
  fd.append("message", payload.message ?? "");
  fd.append("consent", String(payload.consent));

  fd.append("file", payload.file);

  return ApiPost<ApiDetailResponse<any>>(
    `${API_ENDPOINTS.APPLY_JOB}?jobUuid=${jobUuid}`,
    fd
  );
};

export interface CountryApiItem {
  iso: string;
  name: string;
  dialCode: string;
  flag: string;
}

export interface CountryApiResponse {
  success: boolean;
  requestId: string;
  data: CountryApiItem[];
}

/* istanbul ignore next */
export const mapCountryOptions = (countries: CountryApiItem[]): CountryOption[] => {
  return countries.map((c) => ({
    code: c.iso,
    name: c.name,
    dialCode: c.dialCode,
    flag: c.flag,
  }));
};

/* istanbul ignore next */
export const getCountry = () =>
  ApiGet<CountryApiResponse>(API_ENDPOINTS.GET_COUNTRY);